import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HoneycombAnimation from '@/components/HoneycombAnimation';
import { useAuth } from '@/context/AuthContext';
import '@/styles/NotFoundPageStyles.scss'

const NotFoundPage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/');
    }
  }, [user, loading, navigate]);

  return (
      <div
          className="not-found-container"
      style={{
        minHeight: '100vh',
        width: '100vw',
        position: 'relative',
        background: 'var(--background-color)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      >
          <div className="not-found-animation">
              <HoneycombAnimation />
          </div>      
          <div
              className="not-found-content"
              style={{
        marginTop: 'calc(38vh + 180px)', // below logo, centered
        marginLeft: '-60px', // move left for better alignment
        textAlign: 'center',
        width: 420,
        maxWidth: '90vw',
        alignSelf: 'center',
        position: 'relative',
        zIndex: 30
      }}>
        <h1 style={{ fontSize: 36, fontWeight: 700, color: 'var(--text-color)', marginBottom: 12 }}>
          404 - Page Not Found
        </h1>
        <p style={{ color: 'var(--text-color)', marginBottom: 18 }}>
          The page you are looking for does not exist.
        </p>
        <Link
          to="/home"
          style={{
            color: 'var(--primary-color)',
            fontWeight: 700,
            fontSize: 18,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;